import React from "react";

/**
 * @name CCTM_items
 * @function
 * @extends React.Component
 * @exported true
 * @description This component acts as a wrapper that dynamically renders a given component.
 *              It also allows post-processing of the component before rendering.
 * @param {Object} props - Component properties.
 * @param {React.Component} props.component - The component to be rendered.
 * @param {Function} [props.postRender] - Optional function to modify the component before rendering.
 * @param {React.ReactNode} [props.children] - Children elements to be passed to the rendered component.
 * @example
 * export default function CCTM_items(props) {
 *  return (
 *    <CCTM_items component={MyComponent} postRender={(comp, props) => modifyComponent(comp, props)}>
 *      <div>Child Content</div>
 *    </CCTM_items>
 *  );
 * }
 */

// This component acts as a wrapper that dynamically renders a given component
// It also allows post-processing of the component before rendering
export default function CCTM_items(props) {
 
    // Extract the component from props
    let Component = props.component;
    
    // If a postRender function is provided, use it to modify the component before rendering
    if (typeof props.postRender == "function") {
        Component = props.postRender(props.component, props);
    } 
    
    // Render the component with the given props and children
    return (
        <Component {...props}>
            {props.children}
        </Component>
    );
}
